import { render } from "./TypeAheadCustom.vue?vue&type=template&id=533bd5dc"
import script from "./TypeAheadCustom.vue?vue&type=script&lang=js"
export * from "./TypeAheadCustom.vue?vue&type=script&lang=js"

import exportComponent from "/Users/adamklemm/vues/pmp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__